// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import {
	EnviaCentralLiberacaoRequest,
	EnviaCentralLiberacao,
	Types,
} from './types';

export function enviaCentralLiberacaoRequest(
	token: string,
	payload: EnviaCentralLiberacaoRequest,
): ReducerActionRotaSP {
	return {
		type: Types.ENVIA_CENTRAL_LIBERACAO,
		token,
		payload,
	};
}

export function enviaCentralLiberacaoSuccess(
	payload: EnviaCentralLiberacao,
): ReducerActionRotaSP {
	return {
		type: Types.ENVIA_CENTRAL_LIBERACAO_SUCCESS,
		payload,
	};
}

export function enviaCentralLiberacaoFailure(): ReducerActionRotaSP {
	return {
		type: Types.ENVIA_CENTRAL_LIBERACAO_FAILURE,
		payload: null,
	};
}

export function enviaCentralLiberacaoClear(): ReducerActionRotaSP {
	return {
		type: Types.ENVIA_CENTRAL_LIBERACAO_CLEAR,
		payload: null,
	};
}
